<div class="card tipo-sensor-container">
    <p-toolbar styleClass="mb-4 tipo-sensor-toolbar">
        <ng-template pTemplate="left">
            <button pButton pRipple label="Novo" [disabled]="!direitoInserir"
                icon="pi pi-plus" class="p-button-success mr-2" (click)="openNew()"></button>
        </ng-template>
    </p-toolbar>

    <div class="tipo-sensor-table-wrapper" #tableWrapper>
        <p-table #dt [value]="data" [rows]="20" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
            [paginator]="true" [rowHover]="true" dataKey="id"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros" [showCurrentPageReport]="true"
            [globalFilterFields]="['id','tipo_variavel','tipo_grafico','ordem']"
            [scrollable]="true" [scrollHeight]="scrollHeight">

        <ng-template pTemplate="caption">
            <div class="flex p-flex-column p-flex-md-row align-items-center justify-content-between">
                <h5 class="p-m-0">Sensores</h5>
                <span class="p-input-icon-left mt-2 md:mt-0">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Pesquisar..." />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 10%">Código</th>
                <th style="width: 28%">Sensor</th>
                <th style="width: 18%">Tipo Gráfico</th>
                <th style="width: 12%">Ordem</th>
                <th class="col-acoes" style="width: 18%; min-width: 120px">Ações</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dt>
            <tr>
                <td><span class="p-column-title negrito">Código: </span>{{dt.id}}</td>
                <td><span class="p-column-title negrito">Sensor: </span>{{dt.tipo_variavel}}</td>
                <td><span class="p-column-title negrito">Tipo Gráfico: </span>{{dt.tipo_grafico}}</td>
                <td><span class="p-column-title negrito">Ordem: </span>{{dt.ordem}}</td>
                <td class="col-acoes" style="text-align: center; white-space: nowrap">
                    <span class="p-column-title negrito">Ações: </span>
                    <button pButton pRipple [disabled]="!direitoEditar"
                        icon="pi pi-pencil" class="p-button-rounded p-button-primary mr-2"
                        pTooltip="Editar" (click)="edit(dt)"></button>
                    <button pButton pRipple [disabled]="!direitoExcluir"
                        icon="pi pi-trash" class="p-button-rounded p-button-danger"
                        pTooltip="Excluir sensor" (click)="confirmarExclusao(dt)"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5" style="text-align: center;">Nenhum sensor encontrado.</td>
            </tr>
        </ng-template>
        </p-table>
    </div>
</div>

<p-dialog header="Sensor" [(visible)]="displayModal" [modal]="true" [breakpoints]="{'960px': '75vw'}"
    [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div [ngStyle]="{'margin': '7px'}">
        <form [formGroup]="form" class="p-fluid grid">

            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <input type="text" id="tipo_variavel" pInputText formControlName="tipo_variavel">
                    <label for="tipo_variavel">Sensor *</label>
                </p-floatlabel>
                <small *ngIf="form.get('tipo_variavel').invalid && form.get('tipo_variavel').touched" class="p-error">
                    Sensor é obrigatório.
                </small>
            </div>

            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <p-dropdown inputId="tipo_grafico" appendTo="body" [options]="dropDownTipoGrafico"
                        formControlName="tipo_grafico">
                    </p-dropdown>
                    <label for="tipo_grafico">Tipo Gráfico *</label>
                </p-floatlabel>
                <small *ngIf="form.get('tipo_grafico').invalid && form.get('tipo_grafico').touched" class="p-error">
                    Tipo de gráfico é obrigatório.
                </small>
            </div>

            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <p-inputNumber id="ordem" formControlName="ordem" [showButtons]="false" [min]="1">
                    </p-inputNumber>
                    <label for="ordem">Ordem *</label>
                </p-floatlabel>
                <small *ngIf="form.get('ordem').invalid && form.get('ordem').touched" class="p-error">
                    Ordem é obrigatória.
                </small>
            </div>

            <div class="field col-12 md:col-12 xl:col-12">
                <p-checkbox label="Ativo" [binary]="true" formControlName="status"></p-checkbox>
            </div>
        </form>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" icon="pi pi-arrow-left" (click)="displayModal = false" label="Voltar"
            class="p-button-raised p-button-warning mr-2">
        </button>
        <button *ngIf="loading == false" [disabled]="form.invalid" pButton pRipple type="button" icon="pi pi-check" (click)="save()"
            label="Salvar" class="p-button-raised p-button-success"></button>
        <p-progressSpinner *ngIf="loading" [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner"
            strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
    </ng-template>
</p-dialog>

